'use client';

import { Skeleton } from '@/shared/Components';
import { LandingAdvertiseVariant } from '@/shared/types';
import Advertisement from '@/features/NewLanding/Advertisement/Advertisement';
import {
  useAdvertisementsQuery,
  useUpdateAdvertisementClickCountMutation,
} from '@/entities/advertisements';
import { AdvertisementsApiParams } from '@/entities/advertisements/types';

interface AdvertiseContentProps {
  variant: LandingAdvertiseVariant;
}

const landingAdvertisementApiLocation: Record<
  LandingAdvertiseVariant,
  AdvertisementsApiParams['location']
> = {
  'LD-1': 'landing_detail_1',
  'LD-2': 'landing_detail_2',
  'LD-3': 'landing_detail_3',
};

const AdvertiseContent = ({ variant }: AdvertiseContentProps) => {
  const { data, isLoading, isError } = useAdvertisementsQuery({
    location: landingAdvertisementApiLocation[variant],
  });
  const { mutate: updateAdvertisementClickCount } =
    useUpdateAdvertisementClickCountMutation();

  if (isLoading) {
    return <Skeleton className="h-[120px] w-full" />;
  }

  if (!data || isError) return null;

  const props = {
    ...data,
    onClick: () => updateAdvertisementClickCount({ id: data.id }),
  };

  return <Advertisement {...props} variant={variant} />;
};

interface AdvertiseProps {
  variant: LandingAdvertiseVariant;
}

const Advertise = ({ variant }: AdvertiseProps) => {
  return <AdvertiseContent variant={variant} />;
};

export default Advertise;
